module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '90%' : '40%',
      "persistent": ""
    },
    model: {
      value: (_vm.mostrarModal),
      callback: function($$v) {
        _vm.mostrarModal = $$v
      },
      expression: "mostrarModal"
    }
  }, [_c('v-card', {
    staticClass: "popup-modal"
  }, [_c('v-container', [_c('h3', {
    staticClass: "pb-3",
    class: {
      'display-0': _vm.isMobileSize, 'display-1': !_vm.isMobileSize
    }
  }, [_vm._v("\n          Atualização pendente\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_vm._v("\n            Olá "), _c('strong', [_vm._v(_vm._s(_vm.primeiroNome))]), _vm._v(", seus dados cadastrais estão incompletos. Para atualizar,\n            "), _c('router-link', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": {
        name: 'minha-conta.dados-cadastrais'
      }
    }
  }, [_vm._v("\n              clique aqui\n            ")]), _vm._v("\n            .\n            "), _c('br'), _c('br'), _vm._v("\n            * Se após atualizar seus dados essa mensagem persistir, entre em contato com a Central de Atendimento para\n            mais informações.\n          ")], 1)])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModal = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-601d9182!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/popup/ValidaMeusDadosPopup.vue
// module id = 550
// module chunks = 2